import(/* webpackMode: "eager" */ "/home/runner/work/lifti-office-frontend/lifti-office-frontend/src/app/auth/forgotpassword/page.tsx");
